// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getLanguageRequestToJson, getLanguageResponseFromJson, setLanguageRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function setLanguage(request) {
    await fetchRpc('atlas.v1.Languages/SetLanguage', setLanguageRequestToJson(request));
}
export function setLanguage$(request, options) {
    return defer(() => setLanguageWithTransport$(getGlobalTransport(), request, options));
}
export function setLanguageWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Languages/SetLanguage', setLanguageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getLanguage(request) {
    const raw = await fetchRpc('atlas.v1.Languages/GetLanguage', getLanguageRequestToJson(request));
    return getLanguageResponseFromJson(raw);
}
export function getLanguage$(request, options) {
    return defer(() => getLanguageWithTransport$(getGlobalTransport(), request, options));
}
export function getLanguageWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Languages/GetLanguage', getLanguageRequestToJson(request), options)
        .pipe(map(resp => getLanguageResponseFromJson(resp)));
}
